import { useEffect, useState } from 'react';
import { mediaQueries } from '../tokens';

type MediaQueryKey = keyof typeof mediaQueries;

export function useMediaQuery(query: MediaQueryKey | string): boolean {
  const mediaQuery = query in mediaQueries
    ? mediaQueries[query as MediaQueryKey]
    : query;

  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(mediaQuery).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(mediaQuery);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    setMatches(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [mediaQuery]);

  return matches;
}

// Convenience hooks
export function useIsMobile() {
  return !useMediaQuery('md');
}

export function useIsTablet() {
  const isMd = useMediaQuery('md');
  const isLg = useMediaQuery('lg');
  return isMd && !isLg;
}

export function useIsDesktop() {
  return useMediaQuery('lg');
}

export function useIsTouchDevice() {
  return useMediaQuery('touch');
}
